import { QA_CONTEXT_PROFILE_WIDGET } from '../../../constants/qa'
import { getQaSelector } from '../../../utils/common'
import { useWidgetStates } from '../Widget.hooks'
import { WidgetContentContainer } from '../WidgetContentContainer'
import { WidgetContextProvider } from '../WidgetContextProvider'
import { WidgetHeader } from '../WidgetHeader'

import * as styles from './Widget.module.css'

function Widget({
  ContentContainer = WidgetContentContainer,
  Footer,
  Header = WidgetHeader,
  children,
  className = styles.Widget,
  contentContainerProps,
  footerProps,
  headerProps,
  initiallyExpanded,
  isExpanded: isExpandedProp,
  isSkeleton,
  qaName,
  ref,
  title,
  onToggleExpanded,
}) {
  const {
    handleDisableEditMode,
    handleEnableEditMode,
    handleToggleExpanded,
    isEditMode,
    isExpanded,
    registerExpandButton,
  } = useWidgetStates({
    initiallyExpanded,
    isCollapsible: Boolean(Header),
    isExpanded: isExpandedProp,
    onToggleExpanded,
  })

  const qaProps = qaName
    ? getQaSelector({ context: QA_CONTEXT_PROFILE_WIDGET, value: qaName })
    : null

  return (
    <WidgetContextProvider
      isEditMode={isEditMode}
      isExpanded={isExpanded}
      isSkeleton={isSkeleton}
      registerExpandButton={registerExpandButton}
      onDisableEditMode={handleDisableEditMode}
      onEnableEditMode={handleEnableEditMode}
      onToggleExpanded={handleToggleExpanded}
    >
      <div {...qaProps} className={className} ref={ref}>
        {Header ? <Header {...headerProps} title={title} /> : null}
        <ContentContainer {...contentContainerProps}>
          {children}
        </ContentContainer>
        {Footer ? <Footer {...footerProps} /> : null}
      </div>
    </WidgetContextProvider>
  )
}

export default Widget
